__turbopack_context__.v({
  "--is-disabled": "forms-module-scss-module__sp5Zeq__--is-disabled",
  "--is-hidden": "forms-module-scss-module__sp5Zeq__--is-hidden",
  "--is-small": "forms-module-scss-module__sp5Zeq__--is-small",
  "--is-white": "forms-module-scss-module__sp5Zeq__--is-white",
  "__caret": "forms-module-scss-module__sp5Zeq____caret",
  "__checkbox-wrapper": "forms-module-scss-module__sp5Zeq____checkbox-wrapper",
  "__error-message": "forms-module-scss-module__sp5Zeq____error-message",
  "__field": "forms-module-scss-module__sp5Zeq____field",
  "__fieldset": "forms-module-scss-module__sp5Zeq____fieldset",
  "__form": "forms-module-scss-module__sp5Zeq____form",
  "__group": "forms-module-scss-module__sp5Zeq____group",
  "__imageupload-wrapper": "forms-module-scss-module__sp5Zeq____imageupload-wrapper",
  "__instructions": "forms-module-scss-module__sp5Zeq____instructions",
  "__label": "forms-module-scss-module__sp5Zeq____label",
  "__option": "forms-module-scss-module__sp5Zeq____option",
  "__select-wrapper": "forms-module-scss-module__sp5Zeq____select-wrapper",
  "__separator-with-text": "forms-module-scss-module__sp5Zeq____separator-with-text",
  "__textarea-wrapper": "forms-module-scss-module__sp5Zeq____textarea-wrapper",
  "__textfield-wrapper": "forms-module-scss-module__sp5Zeq____textfield-wrapper",
});
